export const filesClear = 'files/clear'
export const mapClear = 'map/clear'
export const projectConfigClear = 'project/config/clear'
export const administrationClear = 'administration/clear'
export const userProfileClear = 'profile/clear'
export const flowConfigClear = '/flow-config/clear'
